import { associatedItemsRenderer } from '@lib/generic.utils'
import { notAnyPriceCheck, notAnyValueCheck } from '@/ag-grid/utils/notAnyValue'
import { agPriceCol } from '@/ag-grid/ag-columns'
import { metadataColDefs } from '@/utils/metadataColDefs'
import ActionsColumn from './ActionsColumn'

export default {
  computed: {
    metadataColDefs,

    columnDefs() {
      return [
        {
          headerName: 'Product',
          field: 'name',
          tooltipField: 'name',
          type: ['textFilterColumn'],
          cellRendererFramework: 'LinkRenderer',
          cellRendererParams: params => ({ route: `/products/${params.data.id}` })
        },

        {
          headerName: 'Publisher',
          field: 'publisher',
          tooltipField: 'publisher.name',
          type: ['textFilterColumn'],
          cellRendererFramework: 'LinkRenderer',
          cellRendererParams: params => ({
            route: `/publishers/${params.data.publisher.id}`,
            value: params.data.publisher.name
          })
        },

        {
          headerName: 'Type',
          field: 'product_type',
          type: ['textFilterColumn'],
          tooltipValueGetter: params => notAnyValueCheck({ ...params, value: params.value?.name }),
          cellRenderer: params => notAnyValueCheck({ ...params, value: params.value?.name })
        },

        {
          headerName: 'Main Subject Category',
          field: 'main_subject_category',
          type: ['textFilterColumn'],
          tooltipValueGetter: params => notAnyValueCheck({ ...params, value: params.value?.name }),
          cellRenderer: params => notAnyValueCheck({ ...params, value: params.value?.name })
        },

        agPriceCol('Active Subscriptions', 'active_subscriptions', {
          cellRenderer: params => params.value ?? 'N/A',
          tooltipValueGetter: params => associatedItemsRenderer(params.value, 'subscription', 'subscriptions')
        }),

        {
          headerName: 'License Manager',
          field: 'owner',
          type: ['textFilterColumn'],
          tooltipValueGetter: params => notAnyValueCheck({ ...params, value: params.value?.name }),
          cellRenderer: params => notAnyValueCheck({ ...params, value: params.value?.name })
        },

        agPriceCol('Total Value Original Currency (incl. One-time purchases)', 'subscription_value_original', {
          cellRenderer: params => notAnyPriceCheck(params, 'subscription_value_original_currency'),
          tooltipValueGetter: params => notAnyPriceCheck(params, 'subscription_value_original_currency', true),
          headerClass: ['multiple-lines', 'text-right'],
          maxWidth: 250
        }),

        agPriceCol('Total Value Local Currency (incl. One-time purchases)', 'subscription_value_local', {
          cellRenderer: params => notAnyPriceCheck(params, 'subscription_value_local_currency'),
          tooltipValueGetter: params => notAnyPriceCheck(params, 'subscription_value_local_currency', true),
          headerClass: ['multiple-lines', 'text-right'],
          maxWidth: 180
        }),

        {
          headerName: 'Actions',
          field: 'actions',
          minWidth: 130,
          maxWidth: 130,
          filter: false,
          sortable: false,
          resizable: false,
          lockVisible: true,
          cellRendererFramework: ActionsColumn
        }
      ]
    },

    gridOptions() {
      return {
        columnDefs: [...this.columnDefs, ...this.metadataColDefs],

        defaultColDef: {
          floatingFilter: true
        },

        suppressRowClickSelection: true,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        cacheBlockSize: 40
      }
    }
  }
}
